import React from 'react';

export default function CloseIcon({ color, size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 18 18`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.29153 9.00244L0.644531 16.6484L1.35253 17.3564L8.99853 9.70944L16.6445 17.3564L17.3525 16.6484L9.70553 9.00244L17.3525 1.35644L16.6445 0.648438L8.99853 8.29544L1.35253 0.648438L0.644531 1.35644L8.29153 9.00244Z"
        fill={color}
      />
    </svg>
  );
}
